export const services = [
    "Addiction Counselor",
    "Marriage & Family Therapist",
    "Adolescent Counselor",
    "Counselling Psychologist",
    "Psychiatrist",
    "Accredited mediator"
]